import { omit } from 'lodash'
import { SubmitHandler } from 'react-hook-form';
import { useNavigate, useParams } from "react-router";
import useUpdateMenu from '../../hooks/Menu/useUpdateMenu'
import useMenu from '../../hooks/Menu/useMenu'
import MenuForm from "./MenuForm";
import Spinner from '../../components/ui/spinner';
import { useToast } from "../../context/ToastContext";

import type { Language } from "../../types/menuTypes";
import type { MenuVariables } from '../../types/menuTypes';

const MenuEdit = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const toast = useToast();
  const { menu, loading, error } = useMenu(id, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
  const { updateMenu } = useUpdateMenu({
    onCompleted: (menuUpdated) => {
      if (menuUpdated.restaurantId) {
        navigate(`/restaurants/${menuUpdated.restaurantId}/menus`);
        toast.success(`Menu ${menuUpdated.name} updated successfully`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  const onSubmit: SubmitHandler<MenuVariables>  = async formValues => {
    try {
      await updateMenu({
        id: id!,
        languages: formValues.languages.map(lang => omit(lang, ['__typename'])) as Language[],
        mainLanguage: formValues.mainLanguage,
        description: formValues.description,
        name: formValues.name,
        currency: {
          code: formValues.currency.code,
          prefix: formValues.currency.prefix,
          symbol: formValues.currency.symbol,
        }
      });
    } catch (err) {
      console.error("menu create error (component):", err);
      // toast
    }
  }

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return menu ? <MenuForm onSubmit={onSubmit} menu={menu} /> : null;
}

export default MenuEdit;
